<template>
    <div v-if="!dossard_bourse_mode">

        <div v-if="!lock_select_parcours || isSuperAdmin">
            <v-dialog width="500" max-width="100%" v-model="deleteDialog" scroll-strategy="none">
                <template v-slot:activator="{ props }">
                    <v-btn variant="elevated" elevation="0" color="red-darken-4" size="small" v-bind="props"> <v-icon
                            icon="mdi-delete"></v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-text>
                        <div class="text-body-1 text-center">
                            Etes-vous sûr de vouloir supprimer l'inscription de <br />
                            <b>{{ nom_coureur }}</b> ?
                        </div>
                        <div class="d-flex justify-center flex-wrap gap mt-2">
                            <v-btn color="dark-red" variant="text" @click="deleteDialog = false">Non</v-btn>
                            <v-btn color="dark-green" variant="text" @click="$emit('onDelete')">Oui</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <div v-if="lock_select_parcours">
            <v-btn variant="elevated" elevation="0" color="red-darken-4" size="small" @click="scrollToTop"> <v-icon
                    icon="mdi-account-group" class="mr-2"></v-icon>
                Gérer l'équipe
            </v-btn>
        </div>
    </div>

</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
    props: ['nom_coureur', 'lock_select_parcours', 'dossard_bourse_mode'],
    name: 'ButtonDeleteInscription',
    computed: {
        ...mapStores(useMainStore),
        isSuperAdmin() {
            return this.mainStore.authAdmin.hasSuperAdminRights;
        }
    },
    data() {
        return {
            deleteDialog: false
        }
    },
    methods: {
        scrollToTop() {
            // scroll to top of the page
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped></style>